import React, { useEffect, useState } from 'react';
import { Checkbox } from '@alifd/next';
import LzMessage from '@/components/common/LzMessage';
import styles from './index.module.scss';

/**
 * opType 固定为 'ALL'
 * @param {*} tagItem 整个标签的信息
 * @param {*} changeData 把组件的值提交到父组件，改变父组件的值
 * @return {*}
 */
const TagCheckbox = ({
  tagItem = {},
  changeData = (data) => {},
  pageType = ''
}) => {
  const limitObj = {
    '短视频一级类目偏好': 5,
    '短视频二级类目偏好': 38,
    '短视频三级类目偏好': 58,
  }
  const hasAllCheck = ['1112']; // 有全部选项的多选框id
  const [checkedAll, setCheckedAll] = useState(false);
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id ?? []); // checkbox组选中的值
  const [valueList, setValueList] = useState(tagItem?.value ?? []); // checkbox组所展示的可选值列表, 如果有 interface 证明这是个需要走接口获取枚举的组件，需要先调一下

  /**
   * 选择时传给父组件
   */
  const changeValue = (val) => {
    let newVal = [...val]
    if(limitObj[tagItem.labelName] && val.length > limitObj[tagItem.labelName]) {
      LzMessage.error('最多只能选择' + limitObj[tagItem.labelName] + '个' + tagItem.labelName, '');
      return ;
    } else {
      if(hasAllCheck.findIndex(item=>item === tagItem.id)>-1)
      {
        if (val.length === tagItem.value.length-1) {
          setCheckedAll(true);
          newVal.push('1');
        } else {
          setCheckedAll(false);
          newVal=newVal.filter((item)=> {return +item !==1})
        }
      }
      
      setData(val);
      changeData({
        opValue: {
          label_id: tagItem.id,
          param_list: [
            {
              param_id: newVal
            }
          ]
        },
        opType: 'ALL'
      });
    }
  };

  useEffect(()=>{
    if(hasAllCheck.findIndex(item=>item === tagItem.id)>-1) {
      setValueList(valueList.filter((item) => item.fieldValue !== '全部'));
      if( pageType==='1'  || (pageType ==='2' && !tagItem.opValue)) { // 如果是创建
        if(tagItem.id==='1112') { // 如果为[近期参加优惠活动人群-活动方]
          let newData = [];
          tagItem?.value.forEach((item)=>{
            if(+item.realValue!==1) {
              newData.push(item.realValue)
            }
          })
          changeValue(newData)
        }
      }
    }
  },[pageType])
  return (
    <div className={`${styles['tag-checkbox']} tag-width`}>
      <div className={styles['checkboxTitleBox']}>
        <div style={{color:'#ff3333'}}>*</div>
        <div>
          {tagItem.labelName}
        </div>
        :
        {
          hasAllCheck.findIndex(item=>item === tagItem.id)>-1 && 
          <Checkbox
            indeterminate={data.length>0 && data.length !== tagItem.value.length-1}
            checked={checkedAll}
            onChange={(v) => {
              setCheckedAll(v)
              if (v) {
                let temp = []
                tagItem.value.forEach((item)=>{
                  if(+item.realValue!==1) {
                    temp.push(item.realValue)
                  }
                })
                changeValue(temp)
              } else {
                changeValue([])
              }
            }}
          >
            全部
          </Checkbox>
        }
        <Checkbox.Group value={data} onChange={(val) => changeValue(val)}>
          {
            valueList.map((its, ins) => (<Checkbox
              style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
              key={ins}
              value={its.realValue}
            >
              {its.fieldValue}
            </Checkbox>))
          }
        </Checkbox.Group>
      </div>
      {
        data.length <= 0 && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelName}
        </div>
      }
    </div>
  );
};
export default TagCheckbox;
